import React, { Component } from 'react';
import spinner from '../images/spinner.gif';

class Spinner extends Component {
  render() {
    return (
      <div style={{textAlign:'center'}}>
        <img style={{width:'32px'}} src={spinner} alt="spinner" />
      </div>
    );
  }
}

export default Spinner;
